export default {
    data() {
        return {
            //所有课程的数据
            data: [],
            //已经被选到的数组
            value: [],
            //学员的id字符串有多个
            idcards: '',
            //学员选课的批次备注
            stuBatch: '',
            renderFunc(h, option) {
                return <span>{option.key} - {option.label}</span>;
            },
            fullscreenLoading: false
        };
    },

    methods: {
        handleChange(value, direction, movedKeys) {
            // // console.log("11",value, direction, movedKeys);
            // // console.log("???",this.value);
        },
        //选课
        chooseClass() {
            //判断选课，学员，批次备注
            if (this.value.length == 0) {
                this.$message({
                    message: '至少选择一门课程',
                    type: 'warning'
                });
            } else if (this.idcards.trim().split('\n').length == 0 || this.idcards.trim().split('\n')[0] == '') {
                this.$message({
                    message: '至少填写一个学员身份证',
                    type: 'warning'
                });
            } else if (this.stuBatch == '') {
                this.$message({
                    message: '请填写批次备注',
                    type: 'warning'
                });
            } else {
                // this.$post('users/get_purchased', {
                //     token: this.$store.state.authority_management,
                //     idcard_arr: JSON.stringify(this.idcards.trim().split('\n')),
                //     offset: 0,
                //     length: 999,
                //     shop_id: this.$store.state.store.id,
                // }).then(res => {
                //     let list = res.data.result.data
                //     let notNullList = []
                    
                //     for (let i = 0; i < list.length; i++) {
                //         if (list[i].product_id != null) {
                //             notNullList.push(list[i])
                //         }
                //     }
                    
                //     // notNullList的长度为空，证明idcard数组中没有人有订单项
                //     if (notNullList.length == 0) {
                //         //发送后台的数据
                //         let data = {
                //             token: this.$store.state.authority_management,
                //             idcard_arr: JSON.stringify(this.idcards.trim().split('\n')),
                //             product_id_arr: JSON.stringify(this.value),
                //             remarks: this.stuBatch,
                //             shop_id: this.$store.state.store.id
                //         }
                //         // // console.log(this.value);
                //         // return false;
                //         //创建批次和选课
                //         this.$post('selected/create_by_idcard', data).then(res => {
                //             let str = '';
                //             res.data.result.status == 'success' ? str = '选课成功' : str = '选课失败';
                //             this.$alert(res.data.result.result, str, {
                //                 confirmButtonText: '确定',
                //             });
                //         })
                //     } else {
                //         // idcard数组中有人有订单项
                //         for (let i = 0; i < notNullList.length; i++) {
                //             this.$message({
                //                 type: 'error',
                //                 message: `身份证为 ${notNullList[i].idcard} 已有课程 “ ${notNullList[i].product_name} ”, 无法开通！`
                //             })
                //         }
                //     }
                // })

                //发送后台的数据
                let data = {
                    token: this.$store.state.authority_management,
                    idcard_arr: JSON.stringify(this.idcards.trim().split('\n')),
                    product_id_arr: JSON.stringify(this.value),
                    remarks: this.stuBatch,
                    shop_id: this.$store.state.store.id
                }
                // // console.log(this.value);
                // return false;
                //创建批次和选课
                this.$post('selected/create_by_idcard', data).then(res => {
                    let str = '';
                    res.data.result.status == 'success' ? str = '选课成功' : str = '选课失败';
                    this.$alert(res.data.result.result, str, {
                        confirmButtonText: '确定',
                    });
                })
            }
        },
        //获取所有课程
        getAllClass() {
            this.fullscreenLoading = true;
            this.$post('products/search', { token: this.$store.state.authority_management, offset: 0, length: 99999, shop_id: this.$store.state.store.id }).then(res => {
                this.fullscreenLoading = false;
                let data = res.data.result.data;
                // // console.log(data)
                for (let i = 0; i < data.length; i++) {
                    data[i].key = i;
                    data[i].label = data[i].name;
                    this.data.push(data[i]);
                }
                // this.data=data;
            })
        },
        leftChange(data) {
            // // console.log(data);
        }
    },
    created() {
        this.getAllClass();
    }
};
